import echarts from "echarts";
import Big from "big.js";

function _toFixed(value, floatWidth) {
	var width = Math.max(0, parseInt(floatWidth, 10) || 0);
	try {
		return new Big(value || 0).toFixed(width);
	} catch (err) {
		return new Big(0).toFixed(width);
	}
}

function _toCompatibleNumber(value) {
	var text = value.toString();
	var numberValue = Number(text);
	return Number.isFinite(numberValue) && new Big(numberValue.toString()).eq(value) ? numberValue : text;
}

function _addDecimals(a, b) {
	try {
		return _toCompatibleNumber(new Big(a || 0).plus(new Big(b || 0)));
	} catch (err) {
		return Number(a || 0) + Number(b || 0);
	}
}

export default {

	install(Vue) {
		//以前的store_Env
		Vue.prototype.lm_env = window.lm_env;
		Vue.prototype.isLogin = function() {
			return !!JSON.parse(localStorage.getItem("login_user_" + window.lm_env));
		};
		Vue.prototype.$echarts = echarts;
		// 生成提示语句
		Vue.prototype.$getTip = function(message, position = "center") {
			let tip = this.$f7.toast.create({
				text: message,
				position: position,
				closeTimeout: 2000
			});
			return tip;
		};
		// 是否为空字符串
		Vue.prototype.$isEmpty = function(a) {
			if (a == undefined) return true;
			if (a == null) return true;
			if (typeof a === "string" && a.trim() == "") return true;
			return false;
		};

		Vue.prototype.$fixNumber = function(v, f) {
			if (f) return _toFixed(v, 2).replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
			else return _toFixed(v, 2);
		};
		Vue.prototype.$fixMoney = function(v, f) {
			var r = _toFixed(v, 2);
			if (new Big(r).abs().gte(10000)) {
				var _r = _toFixed(new Big(r).div(10000), 2).replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
				return _r + '万';
			} else return r.replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
		};
		Vue.prototype.$addNumbers = _addDecimals;

		Vue.prototype.$getDate = function(s) {
			var date = new Date(s * 1);
			var YY = date.getFullYear() + '-';
			var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
			return YY + MM + DD;
		}
	}
}
